<h2 class="mat-h2">Account leaderboard</h2>

<mat-paginator *ngIf="accountLeaderboardDataSource.data.length > 0"
  [pageSizeOptions]="getPageSizeOptions(accountLeaderboardDataSource.data.length)"
  showFirstLastButtons
  aria-label="Select page">
</mat-paginator>

<table mat-table [dataSource]="accountLeaderboardDataSource" matSort class="resize table-fixed firstCol20">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>
  <ng-container matColumnDef="total">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales latest period</th>
    <td mat-cell *matCellDef="let element">{{ element.total }}</td>
  </ng-container>
  <ng-container matColumnDef="delta4Month">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="momentumShortDesc">Sales momentum short</th>
    <td mat-cell *matCellDef="let element">{{ element.delta4Month }}<span *ngIf="element.delta4Month !== 'N/A'">%</span></td>
  </ng-container>
  <ng-container matColumnDef="deltaPY">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="momentumLongDesc">Sales momentum long</th>
    <td mat-cell *matCellDef="let element">{{ element.deltaPY }}<span *ngIf="element.deltaPY !== 'N/A'">%</span></td>
  </ng-container>
  <ng-container matColumnDef="patientPotential">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ getHeader('c_proj_patient_potential1') }}</th>
    <td mat-cell *matCellDef="let element">{{ element.patientPotential }}</td>
  </ng-container>
  <ng-container matColumnDef="patientUtilisation">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ getHeader('patient_utilisation1') }}</th>
    <td mat-cell *matCellDef="let element">{{ element.patientUtilisation }}</td>
  </ng-container>
  <ng-container matColumnDef="percentage">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>%</th>
    <td mat-cell *matCellDef="let element">{{ element.percentage }}</td>
  </ng-container>
  <ng-container matColumnDef="salesUtilisation">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ getHeader('sales_patient_equivalents') }}</th>
    <td mat-cell *matCellDef="let element">{{ element.salesUtilisation }}</td>
  </ng-container>
  <!-- <ng-container matColumnDef="lastUpdate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last KAM update</th>
    <td mat-cell *matCellDef="let element">{{ element.lastUpdate.toLocaleDateString() }}</td>
  </ng-container> -->

  <tr mat-header-row *matHeaderRowDef="accountLeaderBoardDisplayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: accountLeaderBoardDisplayedColumns;" [class]="{ highlight: row.name === 'National average'}"></tr>
</table>
